import React from 'react';
import RouteErrorFallback from './RouteErrorFallback';

interface SafeRouteState {
  hasError: boolean;
  error?: Error;
}

/**
 * Route-level error boundary. Wraps a page so crashes only kill that route.
 */
export default class SafeRoute extends React.Component<{ children: React.ReactNode; name?: string }, SafeRouteState> {
  state: SafeRouteState = { hasError: false };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error(`[SafeRoute:${this.props.name || 'unknown'}] crash:`, error, info);
  }

  handleReset = () => this.setState({ hasError: false, error: undefined });

  render() {
    if (this.state.hasError) {
      return <RouteErrorFallback error={this.state.error} resetError={this.handleReset} />;
    }
    return this.props.children;
  }
}
